import Keycloak from 'keycloak-js';
import Cookies from 'js-cookie';
import { domain } from '../../handleCookies/index';

const KEYCLOAK_COOKIES = [
  'zinierkeycloakurl',
  'zinierkeycloakrealm',
  'zinierkeycloakclientid',
  'zinierkeycloakrefreshtoken',
  'zinierkeycloakidtoken',
  'zinierkeycloakaccesstoken'
];

export const createKeycloakConnection = (authType, orgId) => {
  return new Keycloak({
    url: authType.provider,
    realm: orgId,
    clientId: authType.clientId
  });
};

// Ends the Keycloak session in the background (no redirect) and clears the Keycloak cookies.
// Without this a failed login can't be retried: Keycloak silently reuses the same session
// and the backend rejects it again. Never throws.
export const endKeycloakSession = async () => {
  const [url, realm, clientId, refreshToken] = KEYCLOAK_COOKIES.slice(0, 4)
    .map((name) => Cookies.get(name));
  KEYCLOAK_COOKIES.forEach((name) => Cookies.remove(name, { domain }));
  if (!url || !realm || !clientId || !refreshToken) {
    return;
  }
  try {
    await fetch(`${url}/realms/${encodeURIComponent(realm)}/protocol/openid-connect/logout`, {
      method: 'POST',
      body: new URLSearchParams({ client_id: clientId, refresh_token: refreshToken })
    });
  } catch (_) {
    // Best effort: the session still expires on its own
  }
};
